import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Turnos from "./components/turnos";
import Auth from "./containers/Auth";
import "./App.css";

class App extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route path="/login" component={Auth} />
          <Route path="/" component={Turnos} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js